import config from '../config';

export const FORGOT_PASSWORD_RESET = 'FORGOT_PASSWORD_RESET';
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

function sendForgotPasswordRequest() {
  return {
    type: FORGOT_PASSWORD_REQUEST
  };
}

function receiveForgotPasswordSuccess() {
  return {
    type: FORGOT_PASSWORD_SUCCESS
  };
}

function receiveForgotPasswordFailure() {
  return {
    type: FORGOT_PASSWORD_FAILURE
  };
}

function handleErrors(res) {
  if (!res.ok) {
    throw Error(`${res.status} ${res.statusText}`);
  }
  return res;
}

export function resetForgotPassword() {
  return {
    type: FORGOT_PASSWORD_RESET
  };
}

export function forgotPassword(email) {
  return dispatch => {
    dispatch(sendForgotPasswordRequest());

    return fetch(`${config.api.baseURL}/forgot-password`, {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(handleErrors)
      .then(res => res.json())
      .then(() => dispatch(receiveForgotPasswordSuccess()))
      .catch(() => dispatch(receiveForgotPasswordFailure()));
  };
}
